import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../../../../firebase/src/lib/services/auth.service';
import {getAuth, signInWithEmailLink} from '@angular/fire/auth';
import firebase from 'firebase/compat';

@Component({
    selector: 'app-sso-modal',
    templateUrl: './sso-modal.component.html',
    styleUrls: ['./sso-modal.component.scss']
})
export class SsoModalComponent implements OnInit {
    data: any;
    email = null;
    emailSent = false;
    loading = false;
    error = null;
    warning = null;

    constructor(
        public activeModal: NgbActiveModal,
        public auth: AuthService,
    ) {
    }

    ngOnInit(): void {
    }

    confirmEmail(email?: string) {
        const auth = getAuth();
        signInWithEmailLink(auth, email, this.data)
            .then((result) => {
                this.onClose();
                this.activeModal.close(null);

            })
            .catch((error) => {
                this.generateError(error.code);
            });
    }
    signInModal() {
        this.activeModal.close('SIGN_IN');
    }
    onClose() {
        this.activeModal.close(null);
    }

    generateError(error: string) {
        switch (error) {
            case 'auth/invalid-email':
                this.warning = 'Invalid e-mail';
                return;
            case 'auth/invalid-action-code':
                this.error = 'The link is invalid. This can happen if the link is malformed, expired, or has already been used';
                return;

            default:
                this.error = 'Something goes wrong. Please try again';

        }
    }

}
